export const isValidLonLat = (lon: number, lat: number) => {
    const isValidLatitude = (latitude: number) => typeof latitude === "number" && latitude >= -90 && latitude <= 90;
    const isValidLongitude = (longitude: number) => typeof longitude === "number" && longitude >= -180 && longitude <= 180;

    return isValidLongitude(lon) && isValidLatitude(lat);
};